// extracted by mini-css-extract-plugin
module.exports = {"tableElem":"tableElem__1KMfc","table":"table__2e9pm"};